import { ClockIcon, MapPinIcon, MessageSquareIcon, PhoneIcon } from 'lucide-react';
import { business, images, routes, specialsCopy } from '../data/site';
import { SiteLink } from './SiteLink';
type SpecialsVisitProps = {
  onOpenTextDialog: () => void;
};
export function SpecialsVisit({
  onOpenTextDialog
}: SpecialsVisitProps) {
  return <section aria-labelledby="specials-heading" className="w-full bg-white" data-id="element-223" data-mp="24d6d23hyazde">
      <div className="mx-auto max-w-container px-5 py-12 sm:px-8 lg:py-16" data-id="element-224" data-mp="2s162n03j0jqe">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14" data-id="element-225" data-mp="2x0srk6spvof1">
          <div data-id="element-226" data-mp="2x00sun3tpakj">
            <p className="text-[14px] font-bold uppercase text-pegasus-magenta" data-id="element-227" data-mp="2x2n0emqprq2r">
              {specialsCopy.eyebrow}
            </p>
            <h2 id="specials-heading" className="mt-2 text-h2-mobile font-semibold text-ink lg:text-h2-desktop" data-id="element-228" data-mp="2na7jlsr5l7jg">
              {specialsCopy.heading}
            </h2>
            <p className="mt-4 text-body text-ink/80 sm:text-body-lg" data-id="element-229" data-mp="3frk0564vrasd">{specialsCopy.body}</p>
            <div className="mt-6 flex flex-wrap items-center gap-3" data-id="element-230" data-mp="3o2c0yso6729d">
              <SiteLink to={routes.specials} className="inline-flex min-h-[48px] items-center rounded-btn bg-pegasus-magenta px-6 text-[16px] font-bold text-white transition-colors duration-150 ease-out hover:bg-[#bb2f83]" data-id="element-231" data-mp="3j425egyj9zn8">
                View Current Specials
              </SiteLink>
              <button type="button" onClick={onOpenTextDialog} className="inline-flex min-h-[48px] items-center gap-2 rounded-btn border border-ink/25 px-5 text-[16px] font-medium text-ink transition-colors duration-150 ease-out hover:bg-water" data-id="element-232" data-mp="anfm1c8d6itb">
                <MessageSquareIcon className="h-4 w-4" aria-hidden="true" data-id="element-233" data-mp="fomwxk5szy47" />
                Get Occasional Specials by Text
              </button>
            </div>
          </div>

          <div className="border-t border-ink/10 pt-8 lg:border-l lg:border-t-0 lg:pl-14 lg:pt-0" data-id="element-234" data-mp="2hfgh6kqql3ij">
            <p className="text-[14px] font-bold uppercase text-pine" data-id="element-235" data-mp="373lwbh4yqhvs">Visit Us</p>
            <h2 className="mt-2 text-h2-mobile font-semibold text-ink lg:text-h2-desktop" data-id="element-236" data-mp="3b45soihpphgv">
              See It in Person in Brooklyn
            </h2>

            <div className="mt-5 aspect-[3/2] w-full overflow-hidden rounded-card" data-id="element-237" data-mp="3g1xm5gy09bn6">
              <img src={images.showroom} alt="Exterior of a small-town Main Street storefront with hot tubs visible through large display windows" className="h-full w-full object-cover" loading="lazy" decoding="async" data-id="element-238" data-mp="3l3ekb4p3uk02" />
            </div>

            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-239" data-mp="2qp2p577fooh">
              <div className="flex items-start gap-2.5" data-id="element-240" data-mp="7n753yf2baxn">
                <MapPinIcon className="mt-1 h-5 w-5 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-241" data-mp="cn1shrzmpidy" />
                <address className="text-[16px] not-italic leading-6 text-ink" data-id="element-242" data-mp="hld5gbl8090e">
                  {business.street}
                  <br data-id="element-243" data-mp="22474lfct2ddh" />
                  {business.cityStateZip}
                </address>
              </div>
              <div className="flex items-start gap-2.5" data-id="element-244" data-mp="1x41aztmz6gsr">
                <ClockIcon className="mt-1 h-5 w-5 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-245" data-mp="1s5rbj6u7wu1c" />
                <div className="text-[16px] leading-6 text-ink" data-id="element-246" data-mp="1n6wm3m1qw789">
                  {business.hours.map(entry => <div key={entry.days} data-id="element-247" data-mp="2kuokukggbghy">
                      {entry.days} {entry.time}
                    </div>)}
                </div>
              </div>
            </div>

            <p className="mt-4 flex items-center gap-2.5 text-[16px] text-ink" data-id="element-248" data-mp="2b43n0z8lqg03">
              <PhoneIcon className="h-5 w-5 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-249" data-mp="265ir3c0duihg" />
              <span data-id="element-250" data-mp="33kwiin1dteqr">
                Voice or text{' '}
                <a href={business.phoneHref} className="font-bold text-pegasus-blue underline decoration-pegasus-blue/40 underline-offset-4 transition-colors duration-150 ease-out hover:text-pegasus-magenta" data-id="element-251" data-mp="33mhe8fzfn3q7">
                  {business.phone}
                </a>
              </span>
            </p>

            <div className="mt-6 flex flex-wrap gap-3" data-id="element-252" data-mp="29e8uwxx2r36t">
              <SiteLink to={routes.location} className="inline-flex min-h-[48px] items-center rounded-btn bg-pegasus-blue px-5 text-[16px] font-bold text-white transition-colors duration-150 ease-out hover:bg-ink" data-id="element-253" data-mp="29ftp2mfh8k45">
                Get Directions
              </SiteLink>
              <SiteLink to={routes.contact} className="inline-flex min-h-[48px] items-center rounded-btn border border-ink/25 px-5 text-[16px] font-medium text-ink transition-colors duration-150 ease-out hover:bg-water" data-id="element-254" data-mp="373lnfjq9trdb">
                Contact Pegasus
              </SiteLink>
            </div>
          </div>
        </div>
      </div>
    </section>;
}